<template>
    <div class="main-data-statistics" v-loading="loading">
        <div class="statistics-item" v-for="(i,k) in statisticsData" :key="k">
            <div class="statistics-tit">
                <el-tooltip class="item" effect="dark" :content="statisticsKey[k]+''" placement="left">
                    <span>{{statisticsKey[k]}}</span>
                 </el-tooltip>
             </div>
             <div class="statistics-num">
                 <el-tooltip class="item" effect="dark" :content="i[statisticsKey[k]]+''" placement="left">
                     <span>{{i[statisticsKey[k]]}}</span>
                 </el-tooltip>
             </div>
        </div>
    </div>
</template>

<script>
import { isEmpty } from 'lodash';
import {getFormFieldStatistics} from '@/data-model';
export default{
    components: {

    },
    props: {
        fieldConfig: {
            type: Object
        },
        cacheDataId: {
            type: String,
            default: ''
        },
        isDesign: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            statisticsData: [],
            statisticsKey: [],
            loading: false
        };
    },
    created () {
        if (!isEmpty(this.fieldConfig)) {
            this.initStatistics();
        }
    },
    methods: {
        async initStatistics () {
            this.loading = true;
            this.fieldConfig.cacheDataId = this.cacheDataId;
            this.fieldConfig.isDesign = this.isDesign;
            let res = await getFormFieldStatistics(this.fieldConfig);
            if (res && res.state === 'success') {
                if (res.dataKey.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        let cur = res.data[i];
                        let num = cur[res.dataKey[i]];
                        let str = num.toString();
                        let result = '';
                        if (str.indexOf('.') !== -1) {
                            let pre = str.split('.')[0];
                            result = pre.replace(/\d{1,3}(?=(\d{3})+$)/g, function (s) {
                                return s + ',';
                            });
                            result = result + '.' + str.split('.')[1];
                        } else {
                            result = str.replace(/\d{1,3}(?=(\d{3})+$)/g, function (s) {
                                return s + ',';
                            });
                        }
                        cur[res.dataKey[i]] = result;
                    }
                }
                this.statisticsKey = res.dataKey;
                this.statisticsData = res.data;
            }
            this.loading = false;
        }
    }
};
</script>

<style lang="less">
	.main-data-statistics{
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: 100%;
        position: relative;
        .statistics-item{
            margin-left: 10px;
            padding: 10px;
            height: 80px;
            line-height: 80px;
            width: auto;
            text-align: center;
            border-radius: 6px;
            margin-top: 10px;
            cursor: pointer;
            border: 1px solid #F0F0EE;
            .statistics-num{
                width: auto;
                height: 40px;
                text-align: center;
                line-height: 40px;
                font-size: 20px;
                color: #00ebeb;
                font-weight: 500;
                // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
                -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
                overflow: hidden; /*超出的文本隐藏*/
                text-overflow: ellipsis; /* 溢出用省略号*/
                -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
            }
            .statistics-tit{
                width: auto;
                height: 40px;
                text-align: center;
                line-height: 40px;
                font-size: 18px;
                font-weight: 600;
                //display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
                -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
                overflow: hidden; /*超出的文本隐藏*/
                text-overflow: ellipsis; /* 溢出用省略号*/
                -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
            }
        }
	}
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/StatisticsPreview.vue